import { BrowserRouter, Route, Routes } from "react-router-dom";
import ContactForm from "./components/contactForm/ContactForm";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import theme from "./theme";
import { CacheProvider, ThemeProvider } from "@emotion/react";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

function App() {
  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename="/Biamba-Contact-Form">
          <Routes>
            <Route path="/contact-form" element={<ContactForm />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </CacheProvider>
  );
}

export default App;
